if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.checkoutBtn = this.querySelector('[name="custom_checkout"]');
      this.notifyBtn = document.querySelector('.notify_me_btn.submit_btn');
      // this.topWriteReviewBtn = document.querySelector('.top-write-review-btn');
      this.form.querySelector('[name=id]').disabled = false;
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.onSubmitBISForm = this.onSubmitBISForm.bind(this);
      // this.handleWriteReview = this.handleWriteReview.bind(this);
      this.handleCheckoutBtn = this.handleCheckoutBtn.bind(this);

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.isQuickview = this.closest('[data-quickview-modal]') ? true : false;
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.initSlider();
      // this.initZoom();
      this.initGeneralEvents();
    }

    connectedCallback(){
      setTimeout(function(){
        if(window.innerWidth > 1199){
          $('.mobile-pdp-slider-wrap a').removeAttr('data-fancybox');
        } else {
          $('.product-main-slider a').removeAttr('data-fancybox');
        }
      }, 1000)
    }

    disconnectedCallback(){
      this.form.removeEventListener('submit', this.onSubmitHandler);
      this.checkoutBtn.removeEventListener('click', this.handleCheckoutBtn);
      // if(this.notifyBtn) this.notifyBtn.removeEventListener('click', this.onSubmitBISForm);
      // if(this.topWriteReviewBtn) this.topWriteReviewBtn.removeEventListener('click', this.handleWriteReview);
      const qv = this.closest('.quickview-tpl');
      if(!qv) return;
      if($(qv).find('.product-main-slider.product__media-list').hasClass('slick-initialized')){
        $(qv).find('.product-main-slider.product__media-list').slick('unslick');
      }
      if($(qv).find('.product-thumb-slider').hasClass('slick-initialized')){
        $(qv).find('.product-thumb-slider').slick('unslick');
      }
    }

    initSlider(){
      window.scrollTo(0,0)
      // const imgElemCount = document.querySelector('.product-main-slider.product__media-list').childElementCount;
      let thumbSlider = document.querySelector('.product-photos .product-thumb-slider');
      let mainSlider = document.querySelector('.product-main-slider.product__media-list');
      _theme.toggleLoading(1);
      let thumbSliderChildCount = 0;
      if(!thumbSlider || !mainSlider){
        const thumbInterval = setInterval(function(){
          thumbSlider = document.querySelector('.product-photos .product-thumb-slider');
          mainSlider = document.querySelector('.product-main-slider.product__media-list');
          if(mainSlider && thumbSlider){
            initSliderEvents();
            clearInterval(thumbInterval);
          }
        }, 300);
        setTimeout(function(){
          if(thumbInterval) clearInterval(thumbInterval);
        }, 10000)
      } else {
        thumbSliderChildCount = thumbSlider.childElementCount;
        if(thumbSliderChildCount > 1){
          initSliderEvents();
        }else{
          _theme.toggleLoading();
          $('.product-main-slider.product__media-list').removeClass('hidden');
          $('.mobile-pdp-slider-wrap').removeClass('hidden');
        }
      }

      function initSliderEvents(){
       
        if($('.product-thumb-slider button').length < 5){
          thumbSlider.classList.add('product-thumb-slider-md');
        }
        setTimeout(function(){
          let slidesVisible;
          let scrollableSlides;
          if($('.product-thumb-slider button').length <=5){
            slidesVisible = $('.product-thumb-slider button').length;
          }
          else{
            slidesVisible = 5;
          }
          $('.product-main-slider.product__media-list').removeClass('hidden');
          $('.product-photos .product-thumb-slider').removeClass('hidden');
          $('.mobile-pdp-slider-wrap').removeClass('hidden');
          $('.product-main-slider.product__media-list').on('init', function(event, slick, currentSlide, nextSlide){
            $('.product-main-slider.product__media-list .slick-track').attr({
              'role': 'group',
            });
            // slick.$slider.find('.slick-slide').attr('aria-current', false);
            // slick.$slider.find('.slick-slide.slick-current.slick-active').attr('aria-current', true);
          });

          $('.product-main-slider.product__media-list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var videos = slick.$slider.find('video');
            for (var i = 0; i < videos.length; i++) {
              videos[i].pause();
              videos[i].currentTime = 0; // Reset video to beginning
              // Show play button for paused videos
              var container = videos[i].closest('.video-click-container');
              if (container) {
                var button = container.querySelector('.play-pause-button');
                var playIcon = container.querySelector('.play-icon');
                var pauseIcon = container.querySelector('.pause-icon');
                if (button && playIcon && pauseIcon) {
                  button.style.display = 'flex';
                  playIcon.style.display = 'block';
                  pauseIcon.style.display = 'none';
                }
              }
            }
          });

          $('.product-main-slider.product__media-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
            slick.$slider.find('.slick-slide').attr('aria-current', false);
            // slick.$slider.find('.slick-slide.slick-current.slick-active').attr('aria-current', true);
          });
          $('.product-thumb-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
            slick.$slider.find('.slick-slide').attr('aria-current', false);
            // slick.$slider.find('.slick-slide.slick-current.slick-active').attr('aria-current', true);
          });

          $('.product-thumb-slider').on('init', function(event, slick, currentSlide, nextSlide){
            $('.product-thumb-slider .slick-slide').off('click keyup').on('click keyup',function(evt){
              let run = false;
              if(evt.type && evt.type === 'click'){
                if(evt.pointerId !== -1) run = true;
                if(evt.originalEvent && evt.originalEvent.pointerId !== -1) run = true;
              }
              if(evt.keyCode && evt.keyCode === 13 || evt.keyCode === 32) run = true;
              if(!run) return;
              evt.preventDefault();
              const slickIndex = $(this).attr('data-index');
              $('.product-main-slider.product__media-list').slick('slickGoTo', slickIndex);
      

            });
          });

          $('.product-main-slider.product__media-list').slick({
            fade: true,
            asNavFor: $('.product__media-gallery .product-thumb-slider').length > 0 ? '.product__media-gallery .product-thumb-slider' : null,
            infinite:true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            adaptiveHeight: false, 
            // accessibility: false,
            responsive : [ { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1}}],

          });

            if(window.innerWidth <= 1025){
              const slick = $('.mobile-pdp-slider-wrap').slick({
                infinite : false,
                dots : true,
                arrows : false,
                adaptiveHeight: false, 
              })
              slick.on('beforeChange',function(event, slick, currentSlide, nextSlide){
                // Handle dots aria-selected
                if($('.slick-dots li').hasClass('slick-active')){
                  $('.slick-dots li button').attr('aria-selected',"true")
                }
                else{
                  $('.slick-dots li button').attr('aria-selected',"false")
                }
                
                // Stop all videos when slide changes
                var videos = slick.$slider.find('video');
                for (var i = 0; i < videos.length; i++) {
                  videos[i].pause();
                  videos[i].currentTime = 0; // Reset video to beginning
                  // Show play button for paused videos
                  var container = videos[i].closest('.video-click-container');
                  if (container) {
                    var button = container.querySelector('.play-pause-button');
                    var playIcon = container.querySelector('.play-icon');
                    var pauseIcon = container.querySelector('.pause-icon');
                    if (button && playIcon && pauseIcon) {
                      button.style.display = 'flex';
                      playIcon.style.display = 'block';
                      pauseIcon.style.display = 'none';
                    }
                  }
                }
              })

            }
          $('.product-thumb-slider').slick({
            slidesToShow: slidesVisible,
            slidesToScroll: 1,
            vertical:true,
            dots: false,
            arrows:true,
            verticalSwiping:true,
            arrows: false,
            asNavFor: '.product-main-slider.product__media-list',
            prevArrow:"<button type='button' tabindex='0' role='button' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
            nextArrow:"<button type='button' tabindex='0' role='button' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
            responsive : [
              {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
              },
              {
                breakpoint: 1660,
                settings: {
                    slidesToShow: (slidesVisible > 5) ? slidesVisible - 1.3 : slidesVisible,
                    slidesToScroll: 1,
                    verticalSwiping: false,
                    arrows: true
                }
              },
              {
                breakpoint: 1500,
                settings: {
                    slidesToShow: (slidesVisible > 4) ? slidesVisible - 1.3 : slidesVisible,
                    slidesToScroll: 1,
                    arrows: true
                }
              }
            ]
          });
          
          if($('.product-thumb-slider button').length <= 2 ){
            if($('.product-thumb-slider').hasClass('slick-initialized')){
              $('.product-thumb-slider').slick('unslick')
              $('.product-thumb-slider').addClass('lessButtonShow')
            }
          }
          document.querySelectorAll('.product__media .deferred-media__poster').forEach(button => {
            button.addEventListener('click', function() {
              const wrapper = this.closest('.deferred-media');
              const video = wrapper.querySelector('video');
              wrapper.querySelector('.deferred-media__poster').style.display = 'none';
              video.play();
            });
          });
          _theme.toggleLoading();
        }, 1000);
      }

    }

    initZoom(){
      if(window.innerWidth > 1199){
        $('.mobile-pdp-slider-wrap a').removeAttr('data-fancybox');
      } else {
        $('.product-main-slider a').removeAttr('data-fancybox');
      }
      if($('[data-zoom]').length && window.innerWidth > 1199){
        $('[data-zoom]').trigger('zoom.destroy');
        $('[data-zoom]').zoom();

        window.onresize = debounce(function(event){
          $('[data-zoom]').trigger('zoom.destroy');
          if(window.innerWidth > 1199){
            $('[data-zoom]').zoom();
          }
        }, 500);
      }
    }

    initGeneralEvents(){
      this.form.addEventListener('submit', this.onSubmitHandler);
      this.checkoutBtn.addEventListener('click', this.handleCheckoutBtn);
      // if(this.topWriteReviewBtn) this.topWriteReviewBtn.addEventListener('click', this.handleWriteReview);
      if(this.notifyBtn) this.notifyBtn.addEventListener('click', this.onSubmitBISForm);
    }

    handleCheckoutBtn(evt){
      evt.preventDefault();
      this.checkoutBtn.setAttribute('aria-disabled', true);
      _theme.toggleLoading(1);
      // this.checkoutBtn.classList.add('loading');
      // this.checkoutBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.onSubmitHandler(evt, function(){
        _theme.toggleLoading();
        window.location.href = '/checkout';
      });
    }

    // handleWriteReview(){
    //   const mainWriteReviewBtn = document.querySelector('.bv-write-review');
    //   const firstWrite = document.querySelector('#first-to-write');
    //   if(mainWriteReviewBtn){
    //     mainWriteReviewBtn.click();
    //   } else {
    //     if(firstWrite) firstWrite.click();
    //   }
    // }

    onSubmitBISForm(){
      const error = document.querySelector('.product_alert_signup_modal .error');
      const errorTxt=document.createTextNode('Field is required');
      error.style.display = 'none';
      var productSKU = document.getElementById('txtProductSKU').value;
      var emailAddress = document.getElementById('txtEmailAddress').value;
      var alertCode = document.getElementById('hdnAlertCode').value;
      var checkbox = document.querySelector('.product_alert_signup_modal input#alert_check');
      if(emailAddress.trim().length > 0){
        _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
        _ltk.Alerts.Submit();
         _theme.track.trackData({'event': 'notifyMeFormSubmitted'});
        alert('Thank you! We will notify you when this product becomes available.');
        if(document.querySelector('.product_alert_signup_wrapper')) document.querySelector('.product_alert_signup_wrapper').classList.add('hide');
      } else{
        if(error.textContent.length > 1) {
          error.textContent='';
        }
        error.appendChild(errorTxt);
        error.style.display = 'block';

      }
    }

    onSubmitHandler(evt, callback) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.isQuickview = this.closest('[data-quickview-modal]') ? true : false;
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      _theme.toggleLoading(1);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            _theme.toggleLoading();
            return;
          }

          if(callback && typeof callback === 'function'){
            callback()
          } else {
            // window.location = window.routes.cart_url; return;
            Shopify.getCart(cartdata => {
              _theme.MiniCart.lineItemChangeCallBack(cartdata,() => {
                if(this.isQuickview) $('[data-quickview-modal]').fadeOut();
                _theme.toggleLoading();
                _theme.toggleSideCart(1, null, true);
                _theme.focusTrap($('#dropdown-cart'),function() {
                  _theme.toggleSideCart(false, null, false);
                });
              });
            });
          }

          this.error = false;
          // const quickAddModal = this.closest('quick-add-modal');
          // if (quickAddModal) {
          //   document.body.addEventListener('modalClosed', () => {
          //     setTimeout(() => { this.cart.renderContents(response) });
          //   }, { once: true });
          //   quickAddModal.hide(true);
          // } else {
          //   this.cart.renderContents(response);
          // }
        })
        .catch((e) => {
          _theme.toggleLoading();
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
      _theme.toggleLoading()
    }
  });
}

window.addEventListener('DOMContentLoaded', function(event){
  if($('.product-thumb-slider button').length < 5){
    $('.product-thumb-slider').addClass('product-thumb-slider-md');
  }

  new _theme.ProductRecommendations('#product-recommendations', {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll:5,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: false }},
      { breakpoint: 600, settings: { arrows:false, slidesToShow: 2.3, slidesToScroll: 1 }},
      { breakpoint: 480, settings: { slidesToShow: 2.1, slidesToScroll: 1 }}
    ]
  });

  this.setTimeout(function(){
    const numRating = document.querySelector('.bv_numReviews_text');
    if(!numRating) return;
    const numStr = numRating.textContent;
    const trimmed =  numStr.slice(1,numStr.length-1);
      numRating.textContent = trimmed;
    if(trimmed != 0 ){
      document.querySelector('.product-rating-main').classList.remove('hidden');
    }
  },3000)

  document.querySelector('[data-shipping-return-modal-btn]').addEventListener('click', function (e) {

    const modal = document.querySelector('[data-shipping-return-modal]');
    const modalContent = document.querySelector('[data-shipping-return-modal].show .halo-modal-content');

    modal.style.display = 'block';
    modal.classList.add('show');
    document.body.classList.add('ship-pop');

    const self = this;
    _theme.focusTrap(modalContent, function () {
      modal.style.display = 'none';
      modal.classList.remove('show');
      document.body.classList.remove('ship-pop');
      self.focus();
    }, null, {
      disableLinearNavigation: true,
      enableBackwardJourney: false,
      checkSameElements: true
    });
  });

  document.querySelector('[data-shipping-return-modal] .close').addEventListener('click', function () {
    const modal = document.querySelector('[data-shipping-return-modal]');
    modal.style.display = 'none';
    modal.classList.remove('show');
    document.body.classList.remove('ship-pop');
  });

  document.querySelector('[data-authentic-product-modal-btn]').addEventListener('click', function (e) {

    const modal = document.querySelector('[data-authentic-product-modal]');
    const modalContent = document.querySelector('[data-authentic-product-modal].show .halo-modal-content');

    modal.style.display = 'block';
    modal.classList.add('show');
    document.body.classList.add('ship-pop');

    const self = this;
    _theme.focusTrap(modalContent, function () {
      modal.style.display = 'none';
      modal.classList.remove('show');
      document.body.classList.remove('ship-pop');
      self.focus();
    }, null, {
      disableLinearNavigation: true,
      enableBackwardJourney: false,
      checkSameElements: true
    });
  });

  document.querySelector('[data-authentic-product-modal] .close').addEventListener('click', function () {
    const modal = document.querySelector('[data-authentic-product-modal]');
    modal.style.display = 'none';
    modal.classList.remove('show');
    document.body.classList.remove('ship-pop');
  });

  // Mobile PDP Video Click to Play/Pause functionality
  function initMobileVideoClickToPlay() {
    const videoContainers = document.querySelectorAll('.video-click-container');
    
    videoContainers.forEach(container => {
      const video = container.querySelector('.mobile-pdp-video');
      const playIcon = container.querySelector('.play-icon');
      const pauseIcon = container.querySelector('.pause-icon');
      const button = container.querySelector('.play-pause-button');
      
      if (!video || !playIcon || !pauseIcon || !button) return;
      
      // Click handler for the entire container
      container.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (video.paused) {
          video.play();
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
          button.style.display = 'none';
        } else {
          video.pause();
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
          button.style.display = 'flex';
        }
      });
      
      // Video event listeners
      video.addEventListener('play', function() {
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
        button.style.display = 'none';
      });
      
      video.addEventListener('pause', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        button.style.display = 'flex';
      });
      
      // Since video is set to loop, 'ended' event won't fire, but we keep it for safety
      video.addEventListener('ended', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        button.style.display = 'flex';
      });
      
      // Handle loop restart - keep button hidden during loop
      video.addEventListener('timeupdate', function() {
        if (video.currentTime >= video.duration - 0.1) {
          // Video is about to loop, keep button hidden
          button.style.display = 'none';
        }
      });
    });
  }
  
  // Initialize video click functionality
  initMobileVideoClickToPlay();
  
  // Re-initialize when new content is loaded (for dynamic content)
  document.addEventListener('DOMContentLoaded', initMobileVideoClickToPlay);
  
});

